import React, {useCallback} from 'react';
import { useCheckRole } from '../../utils';
import StudyRequest from '../StudyRequest/StudyRequest';
import {
	AppBar,
	Avatar, Backdrop,
	Box,
	Button, CircularProgress,
	Container,
	IconButton,
	Menu,
	MenuItem, Stack,
	Toolbar,
	Tooltip,
	Typography
} from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from '../../services';
import AdbIcon from "@mui/icons-material/Adb";

const BasicFlowStudyRequest = () => {
	const { t } = useTranslation();
	const { user, isAuthenticated, loginWithRedirect, logout, isLoading} = useAuth0();
	const { accessToBasicFlow } = useCheckRole();
	const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

	const handleCloseUserMenu = useCallback(() => {
		setAnchorElUser(null);
	}, [setAnchorElUser]);

	const handleOpenUserMenu = useCallback(
		(event: React.MouseEvent<HTMLElement>) => {
			setAnchorElUser(event.currentTarget);
		},
		[setAnchorElUser]
	);
	const logoutWithRedirect = () =>
		logout({
			returnTo: `${window.location.origin}/basicFlow`,
		});

	const settings = [{ title: t('Logout'), onClick: logoutWithRedirect }];

	if (isLoading) {
		return <Backdrop
			sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
			open={isLoading}
		>
			<CircularProgress color="inherit" sx={{ m: 1 }} />
			<Stack direction="row" justifyContent="center">
				{t('Please wait...')}
			</Stack>
		</Backdrop>;
	}

	if (!isAuthenticated) {
		loginWithRedirect({redirectUri: `${window.location.origin}/basicFlow`});
	}

	return accessToBasicFlow ? (
		<>
			<AppBar position="static" color="transparent">
				<Container maxWidth="xl">
					<Toolbar disableGutters>
						<Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
							{t('Basic Flow')}
						</Typography>

						<Box sx={{ flexGrow: 0 }}>
							<Tooltip title="Open settings">
								<IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
									<Avatar alt={user?.name} src={user?.picture} />
								</IconButton>
							</Tooltip>
							<Menu
								sx={{ mt: '45px' }}
								id="menu-appbar"
								anchorEl={anchorElUser}
								anchorOrigin={{
									vertical: 'top',
									horizontal: 'right',
								}}
								keepMounted
								transformOrigin={{
									vertical: 'top',
									horizontal: 'right',
								}}
								open={Boolean(anchorElUser)}
								onClose={handleCloseUserMenu}
							>
								{settings.map((setting) => (
									<MenuItem
										key={setting.title}
										onClick={setting.onClick || handleCloseUserMenu}
									>
										<Typography textAlign="center">
											{setting.title}
										</Typography>
									</MenuItem>
								))}
							</Menu>
						</Box>
					</Toolbar>
				</Container>
			</AppBar>
		<StudyRequest basicFlow={true}/>
			</>
	) : (
		<div>
			{t('ACCESS DENIED')}
			<Button onClick={() => logoutWithRedirect()}>{t('Logout')}</Button>
		</div>
	);
};

export default BasicFlowStudyRequest;
